
import TableListRow     from '../TableListRow'
import TableListCol     from '../TableListCol'
import CartItemQuantity from './CartItemQuantity'

export default {
  name: 'ShoppingCartItem',
  inheritAttrs: false,
  components: {
    TableListRow,
    TableListCol,
    CartItemQuantity
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    columns: {
      type: [String, Number, Object],
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    minimal: {
      type: Boolean,
      default: false
    },
    image: {
      type: Boolean,
      default: true
    },
    breakpoint: {
      type: String,
      default: 'sm'
    }
  },
  vessel: {
    price: {
      fontSize: 'md',
      fontWeight: 'semibold'
    },
    label: {
      fontSize: 'sm',
      color: 'grey-darker',
      marginLeft: 'xs'
    }
  },
  computed: {
    isCompact() {
      return this.compact || this.minimal
    },
    editable() {
      return !this.readOnly && !this.isCompact
    },
    hideRemove() {
      return this.readOnly && this.isCompact || this.readOnly && !this.$screen[this.breakpoint]
    },
    rowColumns() {
      const columns = this.columns || (this.compact ? 6 : (this.minimal ? 5 : 10))
      return { all: 2, [this.breakpoint]: columns }
    },
    rowGap() {
      return this.minimal ? 'sm' : 'md'
    },
    removeWidth() {
      return this.$screen[this.breakpoint]
        ? this.minimal ? '2rem' : '3rem'
        : '100%'
    },
    isVariant() {
      return this.item.label != this.item.name
    },
    variantValue() {
      return this.item.variant
        && this.item.variant.options.map(i => i.value).join(', ')
    },
    variantColumnValue() {
      return this.$screen[this.breakpoint]
        ? this.variantValue || '---'
        : this.isVariant ? this.item.label : '---'
    },
    showPopover() {
      return this.isVariant && this.isCompact
        || this.isVariant && this.$screen.current == 'lg'
    },
    showOptions() {
      return this.isCompact ? false : this.$screen.current != 'lg'
    },
    removeAttrs() {
      if (this.$screen[this.breakpoint]) {
        return { tag: 'span' }
      } else {
        return { type: 'danger', width: 'full', size: 'small', plain: true }
      }
    }
  },
  methods: {
    itemImage({ image }) {
      if (image) {
        return {
          ratio: 'square',
          fit: 'cover',
          style: { width: '3rem' },
          ...image
        }
      } else {
        return null
      }
    }
  }
}
